
const FIRST_SENTENCE_REGEX = /([^.?!\n]+[.?!])(\s|$)/

export function getTitleFromText (text) {
    if (!text) return ""
    const firstLinebreak = text.split('\n')[0].trim();
    const m = text.match(FIRST_SENTENCE_REGEX)

    const candidate = (m ? m[1] : firstLinebreak).trim()
    return candidate.length > 140 ? candidate.slice(0,137).trimEnd() + '...' : candidate
}

export function newsObject (raw) {
    return {
        id: raw.id
        ,date: raw.date.slice(0,10) // YYY-MM-DD
        ,text: raw.text
        ,title: raw.title || getTitleFromText(raw.text)
        ,image: raw.imageUrl
        ,mediaType: raw.mediaType
        ,shareLink: raw.shareLinkUrl
        ,mediaUrl: raw.mediaUrl
        ,videoIframeHtml: raw.videoIframeHtml
        ,tags: raw.keywords
        ,display: raw.keywords.length > 1 ? false : raw.display
    }
}

export function sortNews(list) {
    const items = Array.isArray(list) ? list.map(newsObject): []

    items.sort((a, b) => new Date(b.date) - new Date(a.date))
    return items
}